'use client';

import { c as _c } from "react/compiler-runtime";
import IconError from '@/components/assets/icon_error.svg';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import { useVideoUploadStatus } from '@/hooks/useVideoUploadStatus';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
function useRoomVideoStatus() {
  const {
    roomData,
    isTrailer
  } = useCheckEnterRoomContext();
  const isVideoWorld = roomData.scene_type === "blendvision" || !!roomData.vod_id;
  const shouldCheckStatus = isVideoWorld && !isTrailer;
  return useVideoUploadStatus(roomData?.hub_sid, shouldCheckStatus);
}
export function VideoProcessingWarning() {
  const $ = _c(11);
  const t = useTranslations();
  const {
    isMobileLandscape
  } = useUAContext();
  const {
    isProcessing,
    isFailed
  } = useRoomVideoStatus();
  if (!isProcessing && !isFailed) {
    return null;
  }
  const t0 = isMobileLandscape && "col-span-2";
  let t1;
  if ($[0] !== t0) {
    t1 = cn("flex flex-row items-center rounded-lg bg-[#F8E64A] px-4 py-2", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconError className="fill-vive-surface-normal mr-3 size-5 shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isProcessing || $[4] !== t) {
    t3 = isProcessing ? t("room.video-processing-status-warning") : t("room.video-processing-status-warning-failed");
    $[3] = isProcessing;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span className="subheader4-omni-styles text-vive-surface-normal">{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export function VideoProcessingOverlay() {
  const $ = _c(13);
  const t = useTranslations();
  const {
    isMobile
  } = useUAContext();
  const {
    isProcessing,
    isFailed
  } = useRoomVideoStatus();
  if (!isProcessing && !isFailed) {
    return null;
  }
  const t0 = isMobile && "px-[18px]";
  let t1;
  if ($[0] !== t0) {
    t1 = cn("absolute inset-0 z-floating flex h-full w-full items-center justify-center bg-black px-2.5", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isMobile && "text-[15px]";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("text-[32px] font-bold text-white capitalize", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isProcessing || $[5] !== t) {
    t4 = isProcessing ? t("room.video-processing-status-overlay") : t.rich("room.video-processing-status-overlay-failed", {
      link: _temp
    });
    $[4] = isProcessing;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <div className={t1}>{t5}</div>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp(chunks) {
  return <Link className="font-bold underline" href="https://docs.viverse.com/publishing-with-your-viverse-account" target="_blank" rel="noopener noreferrer">{chunks}</Link>;
}